const HYDRATION_EVENT = "[hydration-mismatch]";

function currentEnvironment() {
  return String(import.meta.env.VITE_APP_ENV || import.meta.env.MODE || "").trim();
}

function isSafetyTelemetryEnabled() {
  if (typeof window === "undefined") return false;
  const env = currentEnvironment().toLowerCase();
  return Boolean(import.meta.env.DEV || env === "staging" || env === "development" || env === "dev");
}

function currentRoute() {
  if (typeof window === "undefined") return "";
  return `${window.location.pathname || ""}${window.location.search || ""}`;
}

function cleanPayload(payload = {}) {
  return Object.fromEntries(
    Object.entries(payload).filter(([, value]) => value !== undefined && value !== null && value !== "")
  );
}

export function reportHydrationMismatch(payload = {}) {
  if (!isSafetyTelemetryEnabled()) return;
  const event = cleanPayload({
    route: currentRoute(),
    environment: currentEnvironment(),
    ...payload,
  });
  console.warn(HYDRATION_EVENT, event);
}

export function assertHydrationOwner({
  authUserId,
  hydratedOwnerId,
  source,
  role,
  profileType,
  mismatchType = "owner_mismatch",
} = {}) {
  const authId = String(authUserId || "").trim();
  const ownerId = String(hydratedOwnerId || "").trim();
  if (!authId || !ownerId || authId === ownerId) return true;
  reportHydrationMismatch({
    authUserId: authId,
    hydratedOwnerId: ownerId,
    source,
    role,
    profileType,
    mismatchType,
  });
  return false;
}

export function reportCrossRoleHydration({ source, expectedRole, hydratedRole } = {}) {
  const expected = String(expectedRole || "").trim();
  const hydrated = String(hydratedRole || "").trim();
  if (!expected || !hydrated || expected === hydrated) return;
  reportHydrationMismatch({
    source,
    role: expected,
    hydratedRole: hydrated,
    mismatchType: "cross_role_mismatch",
  });
}
